export const colors = {
  primary: '#C94277',
  primayFont: '#fff',
  secondary: '#EF767A',
  secondaryFont: '#000'
}
